<template>
    <div>
        <div class="mt-4 mb-5 text-left">
            <p class="text-lg mb-1">Gracias por afiliarte</p>
            <p class="text-sm text-muted">Le hemos enviado un enlace de activación a tu correo electrónico registrado. Utilice el enlace de activación para activar tu cuenta.</p>
        </div>
        <form @submit.prevent="RESEND()">
            <p class="input-title mb-3">¿No has recibido el correo?</p>
            <div class="form-group mb-3">
                <button type="submit" class="btn btn-primary btn-x w-100">
                    <div class="spinner-border spinner-border-sm" role="status"
                        v-if="count == 1">
                        <span class="sr-only">Loading...</span>
                    </div>
                    <span v-else>Reenviar correo de activación</span>
                </button>
            </div>
            <div class="form-group">
                <router-link :to="{ name: 'Login' }" class="btn btn-dark btn-x w-100">
                    <span>Atrás para iniciar sesión</span>
                </router-link>
            </div>
        </form>
    </div>
</template>
<script>
export default {
    data() {
        return {
            count: 0,
            slug: this.$route.params.slug,
        }
    },
    methods: {
        RESEND: function () {
            let vue = this
            vue.count++
            if (vue.count == 1) {
                axios({ url: '/resend/email/' + vue.slug, method: 'POST' })
                    .then((resp) => {
                        vue.$swal({ toast: true, icon: 'success', title: resp.data.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    })
                    .catch((err) => {
                        let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    })
                    .finally((resp) => {
                        vue.count = 0
                    })
            }
        }
    }
};
</script>
  


// WEBPACK FOOTER //
// src/pages/auth/Thanks.vue